/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReserveTripMapRoutes
 */
export interface ReserveTripMapRoutes {
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapRoutes
     */
    naviShape?: string;
    /**
     * 
     * @type {number}
     * @memberof ReserveTripMapRoutes
     */
    waitSeconds?: number;
}

export function ReserveTripMapRoutesFromJSON(json: any): ReserveTripMapRoutes {
    return ReserveTripMapRoutesFromJSONTyped(json, false);
}

export function ReserveTripMapRoutesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripMapRoutes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'naviShape': !exists(json, 'navi_shape') ? undefined : json['navi_shape'],
        'waitSeconds': !exists(json, 'wait_seconds') ? undefined : json['wait_seconds'],
    };
}

export function ReserveTripMapRoutesToJSON(value?: ReserveTripMapRoutes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'navi_shape': value.naviShape,
        'wait_seconds': value.waitSeconds,
    };
}


